<!--
 功能名称:时间范围筛选
 开发人:梁高权
 创建时间:2021/03/25
 最后修改时间:2021/03/25
-->
<template>
  <div class="timeScreen-wrap">
    <div class="condition">
      <lunisolar :query_type="query_type" v-on:change="change($event)"/>
      <div class="screen">
        <img src="@/assets/images/screen.png">
        <span @click="showPopup">筛选</span>
      </div>
    </div>
    <van-popup v-model="show" position="bottom" @click-overlay="clickOverlay">
      <van-datetime-picker
        v-model="currentDate"
        item-height="40px"
        :type="dateType"
        title="选择年月日"
        :max-date="maxDate"
        @confirm="confirm"
        @cancel="cancel"
      />
    </van-popup>
  </div>
</template>
<script>
import util from '@/utils/util'
export default {
  name: 'timeScreen',
  components: {
    'lunisolar':() => import('@/components/lunisolar'),
  },
  props: {
    active:Number
  },
  data () {
    return {
      show:false,
      query_type:1,
      query_date:new Date(),
      dateType:'date',
      fmt:'yyyy-MM-dd',
      maxDate: new Date(),
      currentDate: new Date()
    }
  },
  watch: {
   active:{//深度监听，可监听到对象、数组的变化
       handler(newval, oldVal){
		   this.$emit('timeChange',{query_type:this.query_type,query_date:util.formatDate(this.query_date,this.fmt)})
       },
       deep:true ,// true 深度监听
       immediate: true
   },
   query_type(nweVal,oldVal){
     switch(nweVal){
       case 1:
        this.dateType='date';
        this.fmt='yyyy-MM-dd';
        this.$emit('timeChange',{query_type:this.query_type,query_date:util.formatDate(this.query_date,this.fmt)})
        break;
       default:
        this.dateType='year-month';
        this.fmt='yyyy-MM';
        this.$emit('timeChange',{query_type:this.query_type,query_date:util.formatDate(this.query_date,this.fmt)})
     }
   },
   query_date(nweVal,oldVal){
     this.$emit('timeChange',{query_type:this.query_type,query_date:util.formatDate(this.query_date,this.fmt)})
   }
  },
  methods: {
    // 修改日期类型
    change(val){
      this.query_type=val
    },
    // 打开弹窗
    showPopup() {
      this.show = true;
    },
    confirm(val){
      this.query_date=val;
      this.show=false;
    },
    // 关闭弹窗
    cancel(){
      this.currentDate=this.query_date
      this.show=false;
    },
    // 点击遮罩层时触发
    clickOverlay(){
      this.currentDate=this.query_date
    }
  }
}
</script>
<style lang="scss" scoped>
  .timeScreen-wrap {
    .condition{
      padding: 23px 0;
      position: relative;
      display: flex;
      justify-content: center;
      .screen{
        position: absolute;
        right: 30px;
        color: #fff;
        top: 50%;
        transform: translateY(-50%);
        display: flex;
        align-items: center;
        img{
          width: 27px;
          height: 27px;
          margin-right: 13px;
        }
		span{font-size: 28px;}
      }
    }
  }
</style>
